export default __webpack_public_path__ + "e8c75b33c36d48c892341d8db638f2ee.png";